var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"specificComponent",attrs:{"id":_vm.id,"src":_vm.config.url}})}
var staticRenderFns = []

export { render, staticRenderFns }